export const PatientListPage = (destinationLang) => {
  return [
    {
      FormKey: "general-public-patients-list",
      Key: "ليست بيماران",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "patient-list-radio-type-all",
      Key: "همه",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "patient-list-radio-type-ended",
      Key: "مختومه",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "patient-list-radio-type-canceled",
      Key: "انصرافي",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-insurance-list",
      Key: "ليست بيمه ها",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "patient-list-select-services-list",
      Key: "ليست خدمات",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "patient-list-select-diagnosis-list",
      Key: "ليست تشخیص",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "patient-list-input-search-name-id",
      Key: "نام/ نام خانوادگي / کدملي",
      DistinitationLanguage: destinationLang,
    },
  ];
};
